module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp12_7005.83542262.png";